/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_SubtitleInputs */

const tr_kvkkbasvuru_subtitle = /** @type {(inputs: Kvkkbasvuru_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6698 sayılı KVKK Madde 11 haklarınızı kullanmak için başvuru kanalları, zorunlu bilgiler ve yanıt süreleri. Veri sorumlusu: Emonse® E-Ticaret Limited Şirketi.`)
};

const en_kvkkbasvuru_subtitle = /** @type {(inputs: Kvkkbasvuru_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application channels, mandatory information and response periods for exercising your rights under Article 11 of Law No. 6698 (KVKK). Veri Sorumlusu (data controller): Emonse® E-Ticaret Limited Şirketi.`)
};

const de_kvkkbasvuru_subtitle = /** @type {(inputs: Kvkkbasvuru_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antragswege, Pflichtangaben und Antwortfristen für die Ausübung Ihrer Rechte nach Artikel 11 des Gesetzes Nr. 6698 (KVKK). Veri Sorumlusu (Verantwortlicher): Emonse® E-Ticaret Limited Şirketi.`)
};

const ru_kvkkbasvuru_subtitle = /** @type {(inputs: Kvkkbasvuru_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каналы подачи обращения, обязательные сведения и сроки ответа для реализации ваших прав по статье 11 Закона № 6698 (KVKK). Veri Sorumlusu (ответственный за данные): Emonse® E-Ticaret Limited Şirketi.`)
};

/**
* | output |
* | --- |
* | "Application channels, mandatory information and response periods for exercising your rights under Article 11 of Law No. 6698 (KVKK). Veri Sorumlusu (data con..." |
*
* @param {Kvkkbasvuru_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_subtitle = /** @type {((inputs?: Kvkkbasvuru_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_subtitle(inputs)
	if (locale === "de") return de_kvkkbasvuru_subtitle(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_subtitle(inputs)
	return tr_kvkkbasvuru_subtitle(inputs)
});